import React from 'react';
import {
  TextInput,
  Group,
  Button,
  Grid,
  Flex,
  Select,
  MultiSelect,
  Stack
} from '@mantine/core';
import {
  IconSearch
} from '@tabler/icons-react';
import { DateInput } from '@mantine/dates';

const FiltroCarteiras = ({
  form,
  clearFilter,
  handleFilter
}) => {
  const modalidadeOpcoes = [
    { value: "0", label: 'Esportiva' },
    { value: "1", label: 'Recreativa' }
  ];

  const situacaoOpcoes = [
    { value: "0", label: 'Aguardando pagamento do boleto' },
    { value: "1", label: 'Vigente' },
    { value: "2", label: 'Invalidado' },
    { value: "3", label: 'Vencido' },
    { value: "4", label: 'Inativo' },
    { value: "5", label: 'Ativo aguardando pagamento do boleto' },
  ];

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
        handleFilter()
    }
}

  return (
    <Stack onKeyDown={handleKeyDown}>
      <Grid mb="md">
        <Grid.Col span={12}>
          <Flex
            direction={{ base: 'column', sm: 'row' }}
            gap="sm"
            align={{ base: 'stretch', sm: 'flex-end' }}
          >
            <TextInput
              placeholder="Pesquise CPF/Passaporte ou palavra-chave"
              {...form.getInputProps('stringPesquisa')}
              rightSection={<IconSearch size={16} />}
              style={{ flex: 1 }}
            />
            <Group spacing="xs">
              <Button
                color="green"
                fw={'lighter'}
                radius={'xl'}
                onClick={handleFilter}
              >
                Aplicar filtros
              </Button>
              <Button
                  color="green"
                  variant="subtle"
                  fw={'lighter'}
                  radius={'xl'}
                  onClick={clearFilter}
              >
                Limpar
              </Button>
            </Group>
          </Flex>
        </Grid.Col>
      </Grid>

      <Grid mb="md">
        <Grid.Col span={{ base: 12, sm: 6, md: 3 }}>
          <TextInput
            label="Número da Carteira:"
            {...form.getInputProps('numeroCarteira')}
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, sm: 6, md: 3 }}>
          <Select
            label="Modalidade:"
            placeholder="Selecione a modalidade"
            {...form.getInputProps('modalidadeId')}
            data={modalidadeOpcoes}
            clearable
            size="sm"
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 3 }}>
          <DateInput
            label="Período Inicial:"
            {...form.getInputProps('dataInicio')}
            placeholder={'DD/MM/AAAA'}
            size="sm"
            maxLength={10}
            dateParser={value => {
              const data = value.replace(/\D/g, '')
              if (data.length !== 8) {
                return null
              }
              const dia = Number(data.slice(0, 2))
              const mes = Number(data.slice(2, 4)) - 1
              const ano = Number(data.slice(4, 8))
              if (
                typeof dia === 'number' &&
                typeof mes === 'number' &&
                typeof ano === 'number'
              ) {
                return new Date(ano, mes, dia)
              }
              return null
            }}
            maxDate={new Date()}
            valueFormat="DD/MM/YYYY"
            locale="pt-br"
            onKeyDown={e => {
              const input = e.target
              const value = input.value
              const length = value.length
              const key = e.key
              const nextCharIsNumber = /\d/.test(key)
              if (
                nextCharIsNumber &&
                (length === 2 || length === 5) &&
                value[length - 1] !== '/'
              ) {
                input.value = value + '/' + e.key
                e.preventDefault()
              }
            }}
            clearable
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 3 }}>
          <DateInput
            label="Período Final:"
            {...form.getInputProps('dataFinal')}
            placeholder={'DD/MM/AAAA'}
            size="sm"
            maxLength={10}
            dateParser={value => {
              const data = value.replace(/\D/g, '')
              if (data.length !== 8) {
                return null
              }
              const dia = Number(data.slice(0, 2))
              const mes = Number(data.slice(2, 4)) - 1
              const ano = Number(data.slice(4, 8))
              if (
                typeof dia === 'number' &&
                typeof mes === 'number' &&
                typeof ano === 'number'
              ) {
                return new Date(ano, mes, dia)
              }
              return null
            }}
            maxDate={new Date()}
            valueFormat="DD/MM/YYYY"
            locale="pt-br"
            onKeyDown={e => {
              const input = e.target
              const value = input.value
              const length = value.length
              const key = e.key
              const nextCharIsNumber = /\d/.test(key)
              if (
                nextCharIsNumber &&
                (length === 2 || length === 5) &&
                value[length - 1] !== '/'
              ) {
                input.value = value + '/' + e.key
                e.preventDefault()
              }
            }}
            clearable
          />
        </Grid.Col>
        <Grid.Col span={3}>
          <MultiSelect
            label="Situação:"
            placeholder="Selecione as situações"
            {...form.getInputProps('statusId')}
            data={situacaoOpcoes}
            clearable
            searchable
            size="sm"
            value={form.values.statusId || []}
            onChange={(value) => form.setFieldValue('statusId', value)}
            styles={{
              input: {
                minHeight: '36px'
              }
            }}
          />
        </Grid.Col>
      </Grid>
    </Stack>
  );
};

export default FiltroCarteiras;
